<div class="col-12">
    <app-drag-drop-multiple-complemento [inFormatos]="infoArchivo.tipo_archivo" [infoArchivo]="infoArchivo"
        (archivosValidados)="onArchivosValidados($event)" (archivosRechazados)="onArchivosRechazados($event)">
    </app-drag-drop-multiple-complemento>
</div>